<template lang="pug">
.row
    template(v-if="isFromCityEditing")
        .col-md-5
            field(
                type="select",
                label="Город отправки",
                :item="default_from_city",
                search-path="/fias/autocomplete/"
            )
        .col-md-2
            button.btn.btn-default(@click="saveCityFrom",:class="saveButtonCls") Отправляем отсюда
        .col-md-5
    template(v-else)
        .col-md-12 
            .row 
                .col-md-12 Отправка из <b>{{ defaultFromCity && defaultFromCity.full_name }}</b>. 
                    a(@click.prevent="edit") Изменить
                    | .
            .row.margin-top-10(v-if="statuses.length")
                .col-md-12 Информация по <b>загрузке</b> тарифов (загрузка тарифов произойдёт в ночь, 
                    | после того, как Вы проставите API-ключи от служб доставки):
            .row(v-for="status in statuses")
                .col-md-12 {{ status.description }}

</template>

<script>
import { mapState } from 'vuex';

import { getAjaxSearchMethod } from '@/utils/vSelect';

export default {
    name: 'TariffLoadingSettings',
    created() {
        this.getDataHook();
    },
    computed: {
        ...mapState({
            defaultFromCity: state => state.tariffLoading.default_from_city,
            statuses: state => state.tariffLoading.statuses
        }),
        saveButtonCls() {
            return {
                disabled: (
                    !this.default_from_city.value ||
                    !this.default_from_city.value.aoguid ||
                    this.saveButtonDisabled
                )
            };
        }
    },
    methods: {
        getDataHook() {
            this.$store.dispatch('getLoadingSettings')
                .then(_ => {
                    this.default_from_city.value = {...this.defaultFromCity};
                });
        },
        edit() {
            this.isFromCityEditing = true;
            this.saveButtonDisabled = false;
        },
        searchCity: getAjaxSearchMethod(
            '/fias/autocomplete/',
            'citiesChoice'
        ),
        saveCityFrom() {
            this.saveButtonDisabled = true;

            this.$store.dispatch('saveLoadingSettings', {
                default_from_city_id: this.default_from_city.value.aoguid
            }).then(_ => {
                this.isFromCityEditing = false;
            });
        }
    },
    data() {
        return {
            isFromCityEditing: false,
            saveButtonDisabled: false,

            default_from_city: {
                value: null,
                valid: true
            }
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/TariffLoadingSettings.vue